var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"pill":"","color":"light-blue lighten-3"}},[_c('v-avatar',{attrs:{"left":""}},[_c('AvatarView',{attrs:{"sender":_vm.addr,"width":"300","label":"false"}})],1),_vm._v(" "+_vm._s(_vm.profileName)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }